var map = {
	"./1AGP.png": 46204,
	"./2AGP.png": 77953,
	"./3AGP.png": 624,
	"components/Catalog/AGP/img/glass/z/zPlusWhite/1AGP.png": 46204,
	"components/Catalog/AGP/img/glass/z/zPlusWhite/2AGP.png": 77953,
	"components/Catalog/AGP/img/glass/z/zPlusWhite/3AGP.png": 624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51823;